import * as actionTypes from "./activityActions";
import * as TileNames from "../../assets/Resources/HomeButtons.json";

const activityState = {
  name: null,
  linkName: [],
};

const activityReducer = (state = activityState, action) => {
  switch (action.type) {
    case actionTypes.TILE_CLICKED:
      let tilePlaceholder = [];
      TileNames["Tiles"].find((element) => {
        if (element["name"] === action.tileName) {
          tilePlaceholder = element["linkName"];
        }
      });
      return {
        ...state,
        name: action.tileName,
        linkName: tilePlaceholder,
      };

    default:
      return state;
  }
};

export default activityReducer;
